import 'debug';
import { d as pageMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';
import './hotspots.js';
import PanzoomMap from './PanzoomMap.js';
import ImageEntry from './ImageEntry.js';

//
var script = {
  mixins: [pageMixin],
  data: function data() {
    return {
      mapImageEntries: [],
      mapWidth: null,
      mapHeight: null,
      layersCount: 0,
      layer: 0,
      layersMinZoomLevel: [0],
      preload: false
    };
  },
  computed: {
    startCenterPos: function startCenterPos() {
      return this.pageData.StartCenterPos;
    },
    zoomRange: function zoomRange() {
      if (this.pageData.ZoomRange) {
        return this.pageData.ZoomRange;
      } else return {
        max: 100,
        min: 100
      };
    },
    geoData: function geoData() {
      if (this.pageData.Coords) {
        return {
          topLeft: this.pageData.Coords.topLeft,
          bottomRight: this.pageData.Coords.bottomRight,
          diffNorth: this.pageData.DiffNorth,
          system: this.pageData.System
        };
      }

      return null;
    }
  },
  created: function created() {
    if (this.pageData.Sections.length > 0) {
      var entries = this.pageData.Sections[0].entries.filter(function (e) {
        return e.Class === 'Image';
      });

      if (entries.length > 0) {
        this.mapImageEntries = entries;
        this.layersCount = entries.length;
        this.mapWidth = entries[0].Width;
        this.mapHeight = entries[0].Height;
        this.layersMinZoomLevel = [0];
        var zoomRange = this.zoomRange.max - this.zoomRange.min;

        if (zoomRange > 0) {
          for (var i = 1; i <= this.layersCount - 1; i++) {
            this.layersMinZoomLevel.push(this.zoomRange.min + i * (zoomRange / this.layersCount));
          }
        }
      } else {
        console.warn('XpMapPage does not have any image entries.');
      }
    } else {
      console.warn('XpMapPage does not have any section.');
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.preload = true;
    });
  },
  methods: {
    onScaleChanged: function onScaleChanged(scale) {
      if (this.layersCount > 1) {
        for (var i = this.layersCount; i >= 0; i--) {
          if (this.layersMinZoomLevel[i] <= scale) {
            this.switchLayer(i);
            break;
          }
        }
      }
    },
    switchLayer: function switchLayer(newLayer) {
      if (newLayer !== this.layer) {
        this.layer = newLayer;
      }
    }
  },
  components: {
    PanzoomMap: PanzoomMap,
    ImageEntry: ImageEntry
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "c-map-page" },
    [
      _vm.mapHeight && _vm.mapWidth
        ? _c(
            "panzoom-map",
            {
              attrs: {
                height: _vm.mapHeight,
                width: _vm.mapWidth,
                allowZoom: true,
                "start-center": _vm.startCenterPos,
                minZoom: _vm.zoomRange.min > 0 ? _vm.zoomRange.min : -0,
                maxZoom: _vm.zoomRange.max > 0 ? _vm.zoomRange.max : Infinity,
                startZoom: _vm.pageData.StartZoom,
                geoData: _vm.geoData
              },
              on: { scaleChanged: _vm.onScaleChanged }
            },
            _vm._l(_vm.mapImageEntries, function(entry, index) {
              return _c("image-entry", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: index <= _vm.layer,
                    expression: "index <= layer"
                  }
                ],
                key: entry.ID,
                attrs: {
                  localPageData: _vm.pageData,
                  entryData: entry,
                  mode: "map"
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.preload
        ? _c(
            "div",
            { staticClass: "c-map-page--preload" },
            _vm._l(
              _vm.mapImageEntries.filter(function(item, index) {
                return index != 0
              }),
              function(entry) {
                return _c("img", {
                  key: entry.ID,
                  attrs: {
                    src: _vm.$xp.settings.baseUrl + "xpedeo/" + entry.Image.Url,
                    alt: ""
                  }
                })
              }
            ),
            0
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
